
        import 'PeachyTabs.d266b18.css-module'
        export default {"Tabs":"Tabs_PeachyTabs_d266b18"}
    